import {useEffect} from "react";

const SEO = ({pageTitle}) => {
    useEffect(() => {
        document.title = pageTitle + " - PT Raja Alam Raya (RAR)";
    }, []);
};

export default SEO;